'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { LearnContentCarouselCard } from '@module/mdrt-org/shared/block-components/learn-carousel-block/components/learn-content-carousel/components/learn-content-carousel-card';
import { useCarouselMagazineIssueFilter } from '@module/mdrt-org/shared/block-components/learn-carousel-block/components/learn-content-carousel/hooks/use-carousel-magazine-issue-filter';
import { useCarouselSourceFilter } from '@module/mdrt-org/shared/block-components/learn-carousel-block/components/learn-content-carousel/hooks/use-carousel-source-filter';
import { InterestsFormModalDialog } from '@module/mdrt-org/shared/components/interests-form-dialog/interests-form-modal-dialog';
import { type InterestsFormModalCmsContent } from '@module/mdrt-org/shared/utils/types/interests-form-modal-cms-content';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { SettingsIcon } from '@shared/ui-components/svgs';
import { Carousel } from '../../../../components/carousel/carousel';
import { Chip } from '../../../../components/chip/chip';
import { type InterestsData } from '../../../../utils/data/graphql/utils/get-topics';
import { type LearnCarouselCardData } from '../../actions/types';
import { BASED_ON_YOUR_INTERESTS, MOSTLY_VIEWED_CAROUSEL_TYPE } from '../../constants';
import { type LearnGenericTextsCmsContent } from '../../graphql/get-learn-generic-texts-cms-content';
import { MagazineIssueFilterControls } from './components/magazine-issue-filter-controls/magazine-issue-filter-controls';
import { SourceFilterControls } from './components/source-filter-controls/source-filter-controls';
import styles from './learn-content-carousel.module.scss';
export type LearnContentCarouselProps = {
  cards: LearnCarouselCardData[];
  carouselType: null | string;
  className?: string;
  cmsContent: LearnGenericTextsCmsContent;
  ctaLink?: {
    src?: null | string;
    target?: null | string;
    title?: null | string;
  };
  customerInterests: number[];
  iconSrc?: null | string;
  preferencesCmsContent: InterestsFormModalCmsContent;
  preferenceTopics: InterestsData;
  selectedSourcesIds: number[];
  showMagazineIssueFilter: boolean;
  showSourcesFilter: boolean;
  sourcesFilterAllSelectionLabel: null | string | undefined;
  title: string;
};
export const LearnContentCarousel = t0 => {
  const $ = _c(56);
  const {
    cards,
    carouselType,
    className,
    cmsContent,
    ctaLink,
    customerInterests,
    iconSrc,
    preferencesCmsContent,
    preferenceTopics,
    selectedSourcesIds,
    showMagazineIssueFilter,
    showSourcesFilter,
    sourcesFilterAllSelectionLabel,
    title
  } = t0;
  const [isInterestPreferencesModalOpen, setIsInterestPreferencesModalOpen] = useState(false);
  let t1;
  if ($[0] !== cards || $[1] !== selectedSourcesIds || $[2] !== showSourcesFilter || $[3] !== sourcesFilterAllSelectionLabel) {
    t1 = {
      cards,
      selectedSourcesIds,
      showSourcesFilter,
      sourcesFilterAllSelectionLabel
    };
    $[0] = cards;
    $[1] = selectedSourcesIds;
    $[2] = showSourcesFilter;
    $[3] = sourcesFilterAllSelectionLabel;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const sourceFilter = useCarouselSourceFilter(t1);
  const {
    filterCardsBySelectedSource,
    sourceFilterItems
  } = sourceFilter;
  let t2;
  if ($[5] !== cards || $[6] !== showMagazineIssueFilter) {
    t2 = {
      cards,
      showMagazineIssueFilter
    };
    $[5] = cards;
    $[6] = showMagazineIssueFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const magazineIssueFilter = useCarouselMagazineIssueFilter(t2);
  const {
    filterCardsBySelectedMagazineIssue,
    magazineIssueFilterDisplayedItems,
    magazineIssueFilterDropdownItems
  } = magazineIssueFilter;
  let t3;
  if ($[8] !== cards || $[9] !== carouselType || $[10] !== className || $[11] !== cmsContent || $[12] !== ctaLink || $[13] !== customerInterests || $[14] !== filterCardsBySelectedMagazineIssue || $[15] !== filterCardsBySelectedSource || $[16] !== iconSrc || $[17] !== isInterestPreferencesModalOpen || $[18] !== magazineIssueFilter || $[19] !== magazineIssueFilterDisplayedItems || $[20] !== magazineIssueFilterDropdownItems || $[21] !== preferenceTopics || $[22] !== preferencesCmsContent || $[23] !== showMagazineIssueFilter || $[24] !== showSourcesFilter || $[25] !== sourceFilter || $[26] !== sourceFilterItems || $[27] !== title) {
    const filteredCards = filterCardsBySelectedMagazineIssue(filterCardsBySelectedSource(cards));
    const showCardImageWithNumber = carouselType === MOSTLY_VIEWED_CAROUSEL_TYPE;
    const isBasedOnYourInterestsCarousel = carouselType === BASED_ON_YOUR_INTERESTS;
    let t4;
    if ($[29] !== magazineIssueFilterDisplayedItems || $[30] !== magazineIssueFilterDropdownItems || $[31] !== sourceFilterItems) {
      t4 = magazineIssueFilterDropdownItems.find(_temp)?.label || magazineIssueFilterDisplayedItems.find(_temp2)?.label || sourceFilterItems.find(_temp3)?.label;
      $[29] = magazineIssueFilterDisplayedItems;
      $[30] = magazineIssueFilterDropdownItems;
      $[31] = sourceFilterItems;
      $[32] = t4;
    } else {
      t4 = $[32];
    }
    const selectedFilterValue = t4;
    let t5;
    if ($[33] !== ctaLink) {
      t5 = ctaLink ? {
        src: ctaLink.src ?? undefined,
        target: ctaLink.target ?? undefined,
        title: ctaLink.title ?? undefined
      } : undefined;
      $[33] = ctaLink;
      $[34] = t5;
    } else {
      t5 = $[34];
    }
    let t6;
    if ($[35] !== sourceFilter) {
      t6 = <SourceFilterControls filterState={sourceFilter} />;
      $[35] = sourceFilter;
      $[36] = t6;
    } else {
      t6 = $[36];
    }
    let t7;
    if ($[37] !== cmsContent.menuTrigger || $[38] !== magazineIssueFilter) {
      t7 = <MagazineIssueFilterControls filterState={magazineIssueFilter} triggerLabel={cmsContent.menuTrigger} />;
      $[37] = cmsContent.menuTrigger;
      $[38] = magazineIssueFilter;
      $[39] = t7;
    } else {
      t7 = $[39];
    }
    let t8;
    if ($[40] !== customerInterests || $[41] !== isBasedOnYourInterestsCarousel || $[42] !== isInterestPreferencesModalOpen || $[43] !== preferenceTopics || $[44] !== preferencesCmsContent) {
      t8 = isBasedOnYourInterestsCarousel && <ModalTrigger isOpen={isInterestPreferencesModalOpen} renderTrigger={() => <Chip icon={<SettingsIcon />} isRounded={true} label={undefined} onClick={() => setIsInterestPreferencesModalOpen(true)} theme={ChipTheme.Light} />}>{() => <InterestsFormModalDialog allTopics={preferenceTopics} cmsContent={preferencesCmsContent} customerInterests={customerInterests} onSuccessfulSubmit={_temp4} setIsOpen={setIsInterestPreferencesModalOpen} />}</ModalTrigger>;
      $[40] = customerInterests;
      $[41] = isBasedOnYourInterestsCarousel;
      $[42] = isInterestPreferencesModalOpen;
      $[43] = preferenceTopics;
      $[44] = preferencesCmsContent;
      $[45] = t8;
    } else {
      t8 = $[45];
    }
    let t9;
    if ($[46] !== t6 || $[47] !== t7 || $[48] !== t8) {
      t9 = <>{t6}{t7}{t8}</>;
      $[46] = t6;
      $[47] = t7;
      $[48] = t8;
      $[49] = t9;
    } else {
      t9 = $[49];
    }
    let t10;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = {
        laptop: {
          breakpoint: {
            max: 1299,
            min: 1024
          },
          items: 4
        },
        laptopWide: {
          breakpoint: {
            max: 1599,
            min: 1300
          },
          items: 5
        },
        mediumBreakpoint: {
          breakpoint: {
            max: 939,
            min: 768
          },
          items: 4
        },
        mobile: {
          breakpoint: {
            max: 767,
            min: 510
          },
          items: 3
        },
        mobileNarrow: {
          breakpoint: {
            max: 509,
            min: 0
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 1023,
            min: 940
          },
          items: 3
        }
      };
      $[50] = t10;
    } else {
      t10 = $[50];
    }
    let t11;
    if ($[51] !== cmsContent || $[52] !== selectedFilterValue || $[53] !== showCardImageWithNumber || $[54] !== title) {
      t11 = (card, index) => <div key={card?.ContentLink?.GuidValue}><LearnContentCarouselCard card={card} carouselTitle={title} cmsContent={cmsContent} selectedFilterValue={selectedFilterValue} svgNumber={showCardImageWithNumber ? index + 1 : undefined} /></div>;
      $[51] = cmsContent;
      $[52] = selectedFilterValue;
      $[53] = showCardImageWithNumber;
      $[54] = title;
      $[55] = t11;
    } else {
      t11 = $[55];
    }
    t3 = <Carousel className={className} containerClassName={styles.carousel__container} ctaLink={t5} filterAreaNode={t9} iconSrc={iconSrc ?? undefined} itemClassName={styles.carousel__item} resetSlideOnChildrenChange={showSourcesFilter || showMagazineIssueFilter} responsive={t10} title={title}>{filteredCards.map(t11)}</Carousel>;
    $[8] = cards;
    $[9] = carouselType;
    $[10] = className;
    $[11] = cmsContent;
    $[12] = ctaLink;
    $[13] = customerInterests;
    $[14] = filterCardsBySelectedMagazineIssue;
    $[15] = filterCardsBySelectedSource;
    $[16] = iconSrc;
    $[17] = isInterestPreferencesModalOpen;
    $[18] = magazineIssueFilter;
    $[19] = magazineIssueFilterDisplayedItems;
    $[20] = magazineIssueFilterDropdownItems;
    $[21] = preferenceTopics;
    $[22] = preferencesCmsContent;
    $[23] = showMagazineIssueFilter;
    $[24] = showSourcesFilter;
    $[25] = sourceFilter;
    $[26] = sourceFilterItems;
    $[27] = title;
    $[28] = t3;
  } else {
    t3 = $[28];
  }
  return t3;
};
function _temp(dropdownItem) {
  return dropdownItem.selected;
}
function _temp2(filterItem_0) {
  return filterItem_0.selected;
}
function _temp3(filterItem) {
  return filterItem.selected;
}
function _temp4() {
  window.location.reload();
}